<template>
  <div>
    <header class="header">
      <div class="container header-container">
        <h1 class="header-title">Библиотека ВПШ+</h1>
      </div>
    </header>
    <SearchBlock
      @search="searchText = $event"
      @openArticle="(id) => $emit('openArticle', id)"
    />
    <CategoryBlock v-if="!searchText" />
  </div>
</template>

<script>
import SearchBlock from '@/components/blocks/search/SearchBlock.vue';
import CategoryBlock from '@/components/blocks/category/CategoryBlock.vue';

export default {
  name: 'LibPage',
  components: {
    SearchBlock,
    CategoryBlock,
  },
  data() {
    return {
      searchText: '',
    };
  },
};
</script>

<style lang="scss" scoped>
.header {
  position: relative;
  background-color: var(--color-white);
  color: var(--color-black);

  &-container {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 12px;
    position: relative;
    display: flex;
    padding-top: 16px;
    padding-bottom: 16px;
  }
  &-title {
    color: var(--color-black);
    text-align: center;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 125%;
  }
}
</style>
